<template>
  <span class="expand-collapse" v-bind:class="classValue" v-on:click="$emit('toggle')">
  </span>
</template>

<script>
export default {
  name: 'expand-collapse',
  props: ['expanded'],
  computed: {
    classValue: function () {
      if (this.expanded) {
        return 'glyphicon glyphicon-triangle-bottom';
      } else {
        return 'glyphicon glyphicon-triangle-right';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .expand-collapse {
    cursor: pointer;
    // color: darkgray;
  }
</style>



// WEBPACK FOOTER //
// src/components/utilities/expand-collapse.vue